// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"779a3041","213":"51cefe30","732":"1492881a"}[chunkId] + ".chunk.js";
};